/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  getClientes,
  getContratos,
  getIntermediarios,
  getMesesAFacturar,
  getNegociosCarteleria,
  getOportunidades,
  getOportunidadesBTL,
  getUsers,
  log,
} from "../../../utils";
// Fase 3.2b: "cobrada" del filtro/flag se resuelve por resolverCobroVenta (regla 10.264), no por el
// facturafechacobro crudo. cargarCobroPorVenta arma el mapa cobro-por-venta desde el libro (resolverSaldo).
import { cargarCobroPorVenta } from "../../../utils/cobro/cargarCobroVentas";
import { resolverCobroVenta } from "../../../utils/cobro/getCobroFactura";
import { cargarSnapshotPctCongelado } from "../../../utils/comisionSnapshot";
import { derivarDisplayFolio } from "../../../utils/derivarDisplayFolio";
import { getFactoringInfoPorFactura } from "../../../utils/factoring";
import { auditarDualRun } from "../../../utils/lineasFacturacion/auditarDualRun";
import { refKeyDeOportunidad, refKeyDeVinculacion, refKeyLegacyDeVinculacion } from "../../../utils/lineasFacturacion/refKey";
import { derivarClaveHardware, resolverLinea } from "../../../utils/lineasFacturacion/resolverLinea";
import { client } from "../../../utils/supabase";

const possibleYears = ["2024", "2025", "2026", "2027"];

export const useVFDataLoading = (pais, getUFValue, ratesLoaded) => {
  const [todasOportunidades, setTodasOportunidades] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [ejecutivosUnicos, setEjecutivosUnicos] = useState([]);
  const [siiMap, setSiiMap] = useState({});
  const [factoringMap, setFactoringMap] = useState(() => new Map());
  // A3 (7.22): % de intermediación congelado (foto). Vacío/null → todo en vivo.
  const [pctMap, setPctMap] = useState(null);

  useEffect(() => {
    if (!ratesLoaded) return;
    const initialize = async () => {
      try {
        const [
          allOportunidades,
          allIntermediarios,
          allClientes,
          allUsuarios,
          allContratos,
          allNegociosCarteleria,
          edificiosRes,
          pctFrozen,
        ] = await Promise.all([
          getOportunidades({ pais }),
          getIntermediarios({ pais }),
          getClientes({ pais }),
          getUsers(),
          getContratos({ pais }),
          getNegociosCarteleria({ pais }),
          client.from("edificios").select("id, edificio").eq("pais", pais),
          cargarSnapshotPctCongelado(pais).catch(() => null),
        ]);
        setPctMap(pctFrozen);
        const edificiosMap = (edificiosRes.data || []).reduce((acc, e) => ({ ...acc, [e.id]: e.edificio }), {});
        const clientesMap = allClientes.reduce((acc, c) => ({ ...acc, [c.id]: c.nombre }), {});
        const allOportunidadesBTLPromises = possibleYears.map((ano) => getOportunidadesBTL({ pais, ano }));
        const allOportunidadesBTLArrays = await Promise.all(allOportunidadesBTLPromises);
        const allOportunidadesBTL = allOportunidadesBTLArrays.flat();

        // Deduplicate BTL opportunities by ID
        const seenIds = new Set();
        const uniqueOportunidadesBTL = allOportunidadesBTL.filter((btl) => {
          if (seenIds.has(btl.id)) {
            return false;
          }
          seenIds.add(btl.id);
          return true;
        });

        // Mapear oportunidades regulares con el campo ejecutivo
        const mappedOportunidades = allOportunidades.map((op) => {
          let mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
          let ano = new Date().getFullYear().toString();
          if (op.mes_factura && typeof op.mes_factura === "string") {
            const [month, year] = op.mes_factura.split("-");
            if (month && year) {
              mes = month.padStart(2, "0");
              ano = year;
            }
          }
          return {
            ...op,
            type: "pauta",
            ejecutivo: op.ejecutivo ? parseInt(op.ejecutivo, 10) : null,
            mes,
            ano,
          };
        });

        // Mapear oportunidades BTL con executive_responsible
        const filteredOportunidadesBTL = uniqueOportunidadesBTL.filter(
          (btl) => btl.status === 100 && !btl.eliminada && btl.pais === pais
        );
        const mappedOportunidadesBTL = filteredOportunidadesBTL.map((btl) => {
          let mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
          let ano = new Date().getFullYear().toString();
          if (btl.mes_factura && typeof btl.mes_factura === "string") {
            const [month, year] = btl.mes_factura.split("-");
            if (month && year) {
              mes = month.padStart(2, "0");
              ano = year;
            }
          }
          return {
            id: btl.id,
            client_id: btl.client_id,
            importe: btl.total_investment,
            comision: btl.total_commission,
            facturafecha: btl.facturafecha,
            facturanumero: btl.facturanumero,
            facturafechacobro: btl.facturafechacobro,
            mes,
            ano,
            estatus: "100%",
            eliminada: btl.eliminada,
            cliente: allClientes.find((c) => c.id === btl.client_id)?.nombre || "Desconocido",
            type: "BTL",
            moneda_dolar: btl.moneda_dolar || false,
            ejecutivo: btl.executive_responsible ? parseInt(btl.executive_responsible, 10) : null,
          };
        });

        // Explotar contratos: cada mes del JSONB → una fila facturable
        const mappedContratos = (allContratos || [])
          .filter((c) => !c.eliminada && c.estatus === "100%" && c.pais === pais)
          .flatMap((c) =>
            (c.meses || []).map((mesObj, idx) => {
              const [mesStr, anoStr] = (mesObj.mes || "01-2026").split("-");
              return {
                id: `contrato-${c.id}-${idx}`,
                contrato_id: c.id,
                mes_index: idx,
                client_id: c.client_id,
                importe: mesObj.importe || 0,
                comision: null,
                facturafecha: mesObj.facturafecha,
                facturanumero: mesObj.facturanumero,
                facturafechacobro: mesObj.facturafechacobro,
                plazocobro: mesObj.plazocobro,
                mes: mesStr,
                ano: anoStr,
                estatus: "100%",
                eliminada: false,
                cliente: allClientes.find((cl) => cl.id === c.client_id)?.nombre || c.cliente || "Desconocido",
                type: "contrato",
                // Acuerdos a nivel contrato (aplican a todos sus meses): APX (capa aditiva) y override
                // de volumen (ej. OMNET). Necesarios para que VentasFacturas muestre pill + % correcto
                // en las filas-mes de contrato, igual que en pauta (resolución por ID, regla 10.7).
                apx_id: c.apx_id,
                descuento_acuerdo_pct: c.descuento_acuerdo_pct,
                moneda_dolar: c.moneda_dolar || false,
                ejecutivo: c.ejecutivo ? parseInt(c.ejecutivo, 10) : null,
                campana: c.campana,
                label_extra: `Mes ${idx + 1}/${(c.meses || []).length}`,
                personas_comprometidas: c.personas_comprometidas,
                edificios_ids: mesObj.edificios_ids || null,
                pantallas_ascensores: mesObj.pantallas_ascensores || "",
                pantallas_espera: mesObj.pantallas_espera || "",
                pantallas_circulacion: mesObj.pantallas_circulacion || "",
                pantallas_cowork: mesObj.pantallas_cowork || "",
                pantallastotales: mesObj.pantallas_totales || 0,
                display_id: c.display_id || null,
              };
            })
          );

        // L6 tramo 4 (ex L2 dual-run "sombra"): cargar lineas_facturacion (L1, tabla derivada; NADIE la
        // escribe desde la app) y agruparla por negocio para resolver `linea_id` por clave natural.
        // Paginado por si supera el techo de 2000 filas del server (10.167). `linea_id` deja de ser
        // sombra: es la fuente de la refKey de lectura de cartelería/hardware (útil `refKey.js`, 10.1).
        const lineasPorNegocio = new Map();
        try {
          const PAGE = 1000;
          for (let desde = 0; ; desde += PAGE) {
            const { data: pageLineas, error: errLineas } = await client
              .from("lineas_facturacion")
              .select("id, negocio_id, tipo, ano, mes, tramo")
              .order("id", { ascending: true })
              .range(desde, desde + PAGE - 1);
            if (errLineas) {
              log.warn("useVFDataLoading.lineas_facturacion", errLineas);
              break;
            }
            (pageLineas || []).forEach((l) => {
              const k = String(l.negocio_id);
              if (!lineasPorNegocio.has(k)) lineasPorNegocio.set(k, []);
              lineasPorNegocio.get(k).push(l);
            });
            if (!pageLineas || pageLineas.length < PAGE) break;
          }
        } catch (e) {
          log.warn("useVFDataLoading.lineas_facturacion", e);
        }
        const resolverLineaId = (negocioId, clave) => {
          if (!clave) return null;
          return resolverLinea(lineasPorNegocio.get(String(negocioId)) || [], clave)?.id ?? null;
        };

        // Generar filas de cartelería (HW-CAPEX, HW-OPEX, Gestión)
        const mappedCarteleria = [];
        const elegibles = allNegociosCarteleria.filter((n) =>
          ["activo", "100%"].includes((n.estado || "").toLowerCase())
        );
        elegibles.forEach((n) => {
          const pantallas = parseInt(n.cantidad_pantallas, 10) || 1;
          const plazo = parseInt(n.plazo_contrato_meses, 10) || 0;
          const nombreCliente =
            n.tipo_vertical === "TD"
              ? clientesMap[n.referencia_id] || edificiosMap[n.referencia_id] || n.nombre_proyecto || "—"
              : edificiosMap[n.referencia_id] || clientesMap[n.referencia_id] || n.nombre_proyecto || "—";
          const ejecutivoId = n.ejecutivo ? parseInt(n.ejecutivo, 10) : null;
          const mesesFact = n.meses_facturacion
            ? typeof n.meses_facturacion === "string"
              ? JSON.parse(n.meses_facturacion)
              : n.meses_facturacion
            : null;

          // Ventana de facturación mensual (HW-OPEX y Gestión). El corte ya NO es el plazo:
          // mientras el contrato esté activo se generan cuotas hasta el MES ACTUAL inclusive,
          // aunque el plazo haya vencido (helper centralizado getMesesAFacturar, regla 10.1).
          // Además se preservan meses ya facturados que cayeran más allá de esa ventana
          // (defensivo: no perder una fila con match en meses_facturacion). Por `tipo` porque
          // gestion/opex se cruzan por separado contra meses_facturacion.
          const mesesActivo = getMesesAFacturar(n.fecha_inicio, n.plazo_contrato_meses, n.estado);
          const mesesAGenerar = (tipo) => {
            let total = mesesActivo;
            if (n.fecha_inicio && Array.isArray(mesesFact)) {
              const [sy, sm] = n.fecha_inicio.split("-").map((x) => parseInt(x, 10));
              for (const mf of mesesFact) {
                if (mf.tipo !== tipo || !mf.mes || !mf.ano) continue;
                const off = (parseInt(mf.ano, 10) - sy) * 12 + (parseInt(mf.mes, 10) - sm);
                if (off + 1 > total) total = off + 1;
              }
            }
            return total;
          };

          // Label de período. Dentro del plazo: "24/64". Prórroga (mes > plazo, contrato
          // activo vencido): "64 +N" con N = mes − plazo, coherente con el "VENCIDO +N" de
          // cartelería (el plazo firmado queda fijo; +N es la prórroga de hecho).
          const labelPeriodo = (i) => (i + 1 > plazo ? `${plazo} +${i + 1 - plazo}` : `${i + 1}/${plazo}`);

          // Total fee UF del negocio por mes (para prorrateo SII)
          const feeGestionNeg = parseFloat(n.fee_gestion_unitario) || 0;
          const feeOpexNeg = n.incluye_hardware && n.modalidad === "OPEX" ? parseFloat(n.cuota_hardware_opex) || 0 : 0;
          const feeContNeg = n.incluye_contenidos ? parseFloat(n.fee_contenidos_unitario) || 0 : 0;

          // --- HW-CAPEX: una fila por entry en detalle_pagos_hardware ---
          if (n.incluye_hardware && n.modalidad === "CAPEX") {
            const detalle =
              typeof n.detalle_pagos_hardware === "string"
                ? JSON.parse(n.detalle_pagos_hardware || "[]")
                : n.detalle_pagos_hardware || [];
            if (detalle.length > 0) {
              detalle.forEach((entry, idx) => {
                const monto = parseFloat(entry.monto) || 0;
                if (monto <= 0) return;
                const fechaRef = entry.facturafecha || entry.fecha_factura || null;
                // Ubicación en el mes de la grilla = mes de FACTURACIÓN (devengo, 10.143). Cascada:
                // 1) fecha real (`fechaRef`); 2) `fecha_factura_estimada` del tramo (estimación que el
                // usuario carga en FacturacionHardwareModal para el saldo pendiente); 3) `fecha_cierre`
                // como fallback para tramos viejos sin el campo estimado; 4) `fecha_inicio` último recurso
                // defensivo (mismo fallback que la rama CAPEX-sin-detalle de abajo, para no caer al default
                // de enero). `fecha_cobro_estimada` NUNCA se usa acá: es dato de COBRO (Caja/Backlog), no
                // ubica facturación (10.143). `facturafecha` sigue null → la grilla lo pinta "Sin facturar"
                // (no cuenta como facturado) pero SÍ suma al BRUTO/pendiente (10.1: igual que pauta/contrato
                // pendientes; al vincular el DTE real, conciliacionSII le escribe facturafecha/folio).
                const fechaMes = fechaRef || entry.fecha_factura_estimada || n.fecha_cierre || n.fecha_inicio || null;
                const [y, m] = fechaMes ? fechaMes.split("-") : [new Date().getFullYear().toString(), "01"];
                let importeFinal = monto;
                let monedaDolar = n.moneda_hardware === "USD";
                if (n.moneda_hardware === "UF") {
                  importeFinal = monto * (getUFValue(fechaRef || new Date().toISOString().split("T")[0]) || 1);
                  monedaDolar = false;
                }
                mappedCarteleria.push({
                  id: `hw-capex-${n.id}-${idx}`,
                  negocio_id: n.id,
                  display_id: n.id,
                  entry_index: idx,
                  sii_ref_index: idx,
                  // L2 sombra: clave natural hardware espejo de nc_lineas_derivadas (facturafecha||fecha_factura
                  // + tramo por posición en el mes), NO el mes de display de la grilla.
                  linea_id: resolverLineaId(n.id, derivarClaveHardware(detalle, idx)),
                  client_id: null,
                  importe: importeFinal,
                  comision: null,
                  facturafecha: entry.facturafecha || null,
                  facturanumero: entry.facturanumero || null,
                  facturafechacobro: entry.facturafechacobro || null,
                  plazocobro: entry.plazocobro || null,
                  mes: (m || "01").padStart(2, "0"),
                  ano: y || new Date().getFullYear().toString(),
                  estatus: "100%",
                  eliminada: false,
                  cliente: nombreCliente,
                  type: "HW-CAPEX",
                  moneda_dolar: monedaDolar,
                  ejecutivo: ejecutivoId,
                  label_extra: `Pago ${idx + 1}/${detalle.length}`,
                  valor_cuota: monto,
                  moneda_cuota: n.moneda_hardware,
                });
              });
            } else if (parseFloat(n.monto_hardware) > 0) {
              // CAPEX sin detalle: fila única con monto_hardware total
              const fechaRef = n.fecha_cierre || n.fecha_inicio || null;
              const [y, m] = fechaRef ? fechaRef.split("-") : [new Date().getFullYear().toString(), "01"];
              let importeFinal = parseFloat(n.monto_hardware);
              let monedaDolar = n.moneda_hardware === "USD";
              if (n.moneda_hardware === "UF") {
                importeFinal = importeFinal * (getUFValue(fechaRef || new Date().toISOString().split("T")[0]) || 1);
                monedaDolar = false;
              }
              mappedCarteleria.push({
                id: `hw-capex-${n.id}-0`,
                negocio_id: n.id,
                display_id: n.id,
                entry_index: 0,
                sii_ref_index: 0,
                linea_id: null, // CAPEX sin detalle: sin facturafecha → sin tramo datable → sin línea (L1)
                client_id: null,
                importe: importeFinal,
                comision: null,
                facturafecha: null,
                facturanumero: null,
                facturafechacobro: null,
                plazocobro: null,
                mes: (m || "01").padStart(2, "0"),
                ano: y || new Date().getFullYear().toString(),
                estatus: "100%",
                eliminada: false,
                cliente: nombreCliente,
                type: "HW-CAPEX",
                moneda_dolar: monedaDolar,
                ejecutivo: ejecutivoId,
                label_extra: "Pago único",
                valor_cuota: parseFloat(n.monto_hardware),
                moneda_cuota: n.moneda_hardware,
              });
            }
          }

          // --- HW-OPEX: una fila por mes del contrato ---
          if (n.incluye_hardware && n.modalidad === "OPEX" && plazo > 0 && n.fecha_inicio) {
            const cuotaOpex = parseFloat(n.cuota_hardware_opex) || 0;
            if (cuotaOpex > 0) {
              const startDate = new Date(n.fecha_inicio + "T00:00:00");
              const totalMesesOpex = mesesAGenerar("opex");
              for (let i = 0; i < totalMesesOpex; i++) {
                const mesDate = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
                const mesStr = (mesDate.getMonth() + 1).toString().padStart(2, "0");
                const anoStr = mesDate.getFullYear().toString();
                const mesFact = mesesFact?.find((mf) => mf.mes === mesStr && mf.ano === anoStr && mf.tipo === "opex");
                const mesFactIdx = mesesFact?.findIndex(
                  (mf) => mf.mes === mesStr && mf.ano === anoStr && mf.tipo === "opex"
                );
                let importeBase = cuotaOpex * pantallas;
                let monedaDolar = n.moneda_hardware === "USD";
                if (n.moneda_hardware === "UF") {
                  const fechaRef = mesFact?.facturafecha || `${anoStr}-${mesStr}-01`;
                  importeBase = importeBase * (getUFValue(fechaRef) || 1);
                  monedaDolar = false;
                }
                // Proporción de OPEX respecto al total del negocio (para prorrateo SII)
                const totalFeeNeg = (feeOpexNeg + feeGestionNeg + feeContNeg) * pantallas;
                const feeProporcion = totalFeeNeg > 0 ? (cuotaOpex * pantallas) / totalFeeNeg : 1;

                mappedCarteleria.push({
                  id: `hw-opex-${n.id}-${i}`,
                  negocio_id: n.id,
                  display_id: n.id,
                  mes_index: i,
                  sii_ref_index: mesFactIdx >= 0 ? mesFactIdx : null,
                  // L2 sombra: opex → clave natural (tipo, ano, mes, tramo=1), igual que nc_lineas_derivadas.
                  linea_id: resolverLineaId(n.id, { tipo: "opex", ano: anoStr, mes: mesStr, tramo: 1 }),
                  client_id: null,
                  importe: importeBase,
                  comision: null,
                  feeOpexUF: cuotaOpex * pantallas,
                  feeProporcion,
                  facturafecha: mesFact?.facturafecha || null,
                  facturanumero: mesFact?.facturanumero || null,
                  facturafechacobro: mesFact?.facturafechacobro || null,
                  plazocobro: mesFact?.plazocobro || null,
                  mes: mesStr,
                  ano: anoStr,
                  estatus: "100%",
                  eliminada: false,
                  cliente: nombreCliente,
                  type: "HW-OPEX",
                  moneda_dolar: monedaDolar,
                  ejecutivo: ejecutivoId,
                  label_extra: `Mes ${labelPeriodo(i)}`,
                  valor_cuota: cuotaOpex * pantallas,
                  moneda_cuota: n.moneda_hardware,
                });
              }
            }
          }

          // --- Gestión & Contenidos: una fila por mes (solo EO/TD, no OT) ---
          if (n.tipo_vertical !== "OT" && plazo > 0 && n.fecha_inicio) {
            const feeGestion = parseFloat(n.fee_gestion_unitario) || 0;
            const feeContenidosBase = n.incluye_contenidos ? parseFloat(n.fee_contenidos_unitario) || 0 : 0;
            const contInicio = n.contenidos_fecha_inicio ? new Date(n.contenidos_fecha_inicio + "T00:00:00") : null;
            const contFin = n.contenidos_fecha_fin ? new Date(n.contenidos_fecha_fin + "T00:00:00") : null;

            if (feeGestion > 0 || feeContenidosBase > 0) {
              const startDate = new Date(n.fecha_inicio + "T00:00:00");
              const totalMesesGestion = mesesAGenerar("gestion");
              for (let i = 0; i < totalMesesGestion; i++) {
                const mesDate = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
                const mesStr = (mesDate.getMonth() + 1).toString().padStart(2, "0");
                const anoStr = mesDate.getFullYear().toString();

                // Contenidos solo aplica dentro del rango de fechas (si está definido)
                const mesEnRangoContenidos =
                  feeContenidosBase > 0 && (!contInicio || !contFin || (mesDate >= contInicio && mesDate <= contFin));
                const feeContenidos = mesEnRangoContenidos ? feeContenidosBase : 0;

                // Calcular importe según moneda
                const mesFact = mesesFact?.find(
                  (mf) => mf.mes === mesStr && mf.ano === anoStr && mf.tipo === "gestion"
                );
                const mesFactIdx = mesesFact?.findIndex(
                  (mf) => mf.mes === mesStr && mf.ano === anoStr && mf.tipo === "gestion"
                );
                const fechaRef = mesFact?.facturafecha || `${anoStr}-${mesStr}-01`;

                let importeGestion = feeGestion * pantallas;
                let importeContenidos = feeContenidos * pantallas;
                let monedaDolar = n.moneda_gestion === "USD";

                if (n.moneda_gestion === "UF") {
                  const ufVal = getUFValue(fechaRef) || 1;
                  importeGestion = importeGestion * ufVal;
                  monedaDolar = false;
                }
                // Contenidos puede tener moneda diferente (CLP vs UF)
                if (mesEnRangoContenidos && n.moneda_contenidos === "UF") {
                  const ufVal = getUFValue(fechaRef) || 1;
                  importeContenidos = importeContenidos * ufVal;
                } // Si moneda_contenidos es CLP, importeContenidos ya está en CLP

                const importeBase = importeGestion + importeContenidos;
                const feeTotal = feeGestion * pantallas + feeContenidos * pantallas;

                // Proporción de gestión+contenidos respecto al total del negocio (para prorrateo SII)
                const totalFeeNeg = (feeOpexNeg + feeGestionNeg + (mesEnRangoContenidos ? feeContNeg : 0)) * pantallas;
                const feeProporcion = totalFeeNeg > 0 ? feeTotal / totalFeeNeg : 1;

                mappedCarteleria.push({
                  id: `gestion-${n.id}-${i}`,
                  negocio_id: n.id,
                  display_id: n.id,
                  mes_index: i,
                  sii_ref_index: mesFactIdx >= 0 ? mesFactIdx : null,
                  // L2 sombra: gestión → clave natural (tipo, ano, mes, tramo=1), igual que nc_lineas_derivadas.
                  linea_id: resolverLineaId(n.id, { tipo: "gestion", ano: anoStr, mes: mesStr, tramo: 1 }),
                  client_id: null,
                  importe: importeBase,
                  comision: null,
                  importeGestion,
                  importeContenidos,
                  feeProporcion,
                  feeGestionUF: n.moneda_gestion === "UF" ? feeGestion * pantallas : null,
                  feeContenidosUF:
                    mesEnRangoContenidos && n.moneda_contenidos === "UF" ? feeContenidos * pantallas : null,
                  feeContenidosCLP:
                    mesEnRangoContenidos && n.moneda_contenidos === "CLP" ? feeContenidos * pantallas : null,
                  facturafecha: mesFact?.facturafecha || null,
                  facturanumero: mesFact?.facturanumero || null,
                  facturafechacobro: mesFact?.facturafechacobro || null,
                  plazocobro: mesFact?.plazocobro || null,
                  mes: mesStr,
                  ano: anoStr,
                  estatus: "100%",
                  eliminada: false,
                  cliente: nombreCliente,
                  type: "Gestión",
                  moneda_dolar: monedaDolar,
                  ejecutivo: ejecutivoId,
                  label_extra: labelPeriodo(i),
                  valor_cuota: feeTotal,
                  moneda_cuota: n.moneda_gestion,
                  incluye_contenidos: mesEnRangoContenidos,
                });
              }
            }
          }
        });

        // Cargar vinculaciones SII con detalle por concepto
        const { data: siiVinculadas } = await client
          .from("facturas_sii_emitidas")
          .select(
            "folio, id, fecha_emision, monto_neto, monto_exento, monto_total, tipo_dte, plazocobro, facturafechacobro, estado_factoring, " +
              "facturas_sii_vinculaciones(venta_tipo, venta_ref_id, venta_ref_index, linea_id, monto_aplicado)"
          )
          .eq("pais", pais)
          .eq("estado_vinculacion", "vinculada");

        // Fase 3.2b (10.264): mapa cobro-por-venta desde el libro (resolverSaldo). El filtro/flag
        // "cobrada" se deriva de acá vía resolverCobroVenta; las ventas sin documento fiscal (pre-SII)
        // caen al facturafechacobro manual (via='manual_pre_sii') dentro del helper.
        const cobroPorVenta = await cargarCobroPorVenta(pais).catch(() => new Map());

        // L6 tramo 4: `_byRef` se indexa por `refKeyDeVinculacion` (cartelería/hardware → `linea:<id>`,
        // pauta/BTL/contrato → la key legacy, sin cambios — 10.1). `_byRefLegacy` (SOLO dev, nunca se usa
        // para decidir nada) indexa la MISMA data por la key posicional vieja, para que el dual-run de
        // auditoría siga comparando método viejo vs método nuevo (antes comparaba posición vs sombra).
        const siiMapData = { _byRef: {} };
        const byRefLegacyDev = process.env.NODE_ENV !== "production" ? {} : null;
        (siiVinculadas || []).forEach((f) => {
          const montoNeto = f.monto_neto || f.monto_exento || 0;
          siiMapData[String(f.folio)] = {
            facturaId: f.id,
            montoNeto, // F3: para derivar la atribución (resolverAtribucionFactura) por factura
            vinculaciones: f.facturas_sii_vinculaciones || [],
            plazocobro: f.plazocobro ?? null,
            facturafechacobro: f.facturafechacobro ?? null,
            estadoFactoring: f.estado_factoring ?? null,
          };
          (f.facturas_sii_vinculaciones || []).forEach((v) => {
            const entry = {
              facturaId: f.id,
              folio: f.folio,
              fechaEmision: f.fecha_emision,
              montoNeto,
              montoAplicado: v.monto_aplicado ?? null, // F3: fuente única del importe por fila
              montoTotal: f.monto_total,
              tipoDte: f.tipo_dte,
              plazocobro: f.plazocobro ?? null,
              facturafechacobro: f.facturafechacobro ?? null,
              estadoFactoring: f.estado_factoring ?? null,
            };
            const key = refKeyDeVinculacion(v);
            if (key) siiMapData._byRef[key] = entry;
            if (byRefLegacyDev) {
              const legacyKey = refKeyLegacyDeVinculacion(v);
              if (legacyKey) byRefLegacyDev[legacyKey] = entry;
            }
          });
        });
        setSiiMap(siiMapData);

        // Operaciones de factoring activas/liquidadas → Map<factura_sii_emitida_id, {...}>
        // para la columna "Factoring" en la tabla de VentasFacturas. Fuente única (10.1/10.27):
        // getFactoringInfoPorFactura indexa por FK directa UNION puente — una op multi-factura
        // (413452) deja una entrada por CADA factura, no solo por la FK directa.
        setFactoringMap(await getFactoringInfoPorFactura(pais));

        // Override plazocobro y facturafechacobro desde SII si hay vinculación.
        // Además computa _displayFolio (folio de la vinculación por ID, fallback al texto
        // facturanumero) con la función única que también usa recargarSiiMap (P2.100).
        const injectSIIDates = (op) => {
          const key = refKeyDeOportunidad(op);
          const byRef = key ? siiMapData._byRef[key] : null;
          const bySII = byRef || (op.facturanumero && siiMapData[String(op.facturanumero)]) || null;
          const _displayFolio = derivarDisplayFolio(op, siiMapData);
          // Fase 3.2b (10.264): "cobrada" por venta. Con documento en el puente (key en cobroPorVenta) →
          // resolverSaldo; sin documento (pre-SII) → facturafechacobro manual (via='manual_pre_sii'). Se
          // usa la key de refKeyDeOportunidad (reuso, no duplica el switch de modelos). facturafechacobro para el
          // fallback = el propio de la venta (el bySII solo aplica a vinculadas, que resuelven por libro).
          const _cobroReal = resolverCobroVenta({ _key: key, facturafechacobro: op.facturafechacobro }, cobroPorVenta);
          if (!bySII) return { ...op, _displayFolio, _cobroReal };
          return {
            ...op,
            _displayFolio,
            _cobroReal,
            plazocobro: bySII.plazocobro ?? op.plazocobro,
            facturafechacobro: bySII.facturafechacobro ?? op.facturafechacobro,
          };
        };

        const combinedOportunidades = [
          ...mappedOportunidades,
          ...mappedOportunidadesBTL,
          ...mappedContratos,
          ...mappedCarteleria,
        ].map(injectSIIDates);

        // L2 · Auditoría del dual-run (SOLO desarrollo): un único log.info por carga con el resumen
        // (divergencias método posición↔clave natural — esperado 0 — y excepciones opex conocidas).
        // Nunca en producción, nunca por fila, nunca decide ni renderiza nada.
        if (process.env.NODE_ENV !== "production") {
          const auditoria = auditarDualRun(combinedOportunidades, siiMapData, byRefLegacyDev);
          log.info("VF dual-run L6 tramo 4 (key legacy vs linea_id)", {
            pais,
            filasCarteleria: auditoria.filas,
            conVinculo: auditoria.conVinculo,
            divergencias: auditoria.divergencias.length,
            clavesDivergentes: auditoria.divergencias.map((d) => d.refKey),
            excepcionesOpexConocidas: auditoria.excepcionesOpex.length,
            clavesExcepcionOpex: auditoria.excepcionesOpex.map((e) => e.refKey),
          });
        }

        setTodasOportunidades(combinedOportunidades);
        setIntermediarios(allIntermediarios);
        setClientes(allClientes);
        setUsuarios(allUsuarios);

        // Mapear ejecutivos únicos basados en los IDs con ventas al 100%
        const uniqueEjecutivoIds = [
          ...new Set(combinedOportunidades.map((op) => op.ejecutivo).filter((id) => id !== null)),
        ];
        const ejecutivosUnicosList = uniqueEjecutivoIds
          .map((ejecutivoId) => {
            const usuario = allUsuarios.find((u) => parseInt(u.id, 10) === ejecutivoId);
            return usuario ? { id: ejecutivoId, nombre: usuario.nombre } : null;
          })
          .filter((u) => u !== null)
          .sort((a, b) => a.nombre.localeCompare(b.nombre));
        setEjecutivosUnicos(ejecutivosUnicosList);
      } catch (error) {
        console.error("Error al inicializar datos:", error);
        log.error("initialize", error);
        toast.error("Error al cargar los datos iniciales");
      }
    };
    initialize();
  }, [pais, ratesLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  const recargarSiiMap = async () => {
    const { data } = await client
      .from("facturas_sii_emitidas")
      .select(
        "folio, id, fecha_emision, monto_neto, monto_exento, monto_total, tipo_dte, plazocobro, facturafechacobro, " +
          "facturas_sii_vinculaciones(venta_tipo, venta_ref_id, venta_ref_index, linea_id, monto_aplicado)"
      )
      .eq("pais", pais)
      .eq("estado_vinculacion", "vinculada");
    const map = { _byRef: {} };
    (data || []).forEach((f) => {
      const montoNeto = f.monto_neto || f.monto_exento || 0;
      map[String(f.folio)] = {
        facturaId: f.id,
        montoNeto, // F3: para derivar la atribución por factura
        vinculaciones: f.facturas_sii_vinculaciones || [],
        plazocobro: f.plazocobro ?? null,
        facturafechacobro: f.facturafechacobro ?? null,
        estadoFactoring: f.estado_factoring ?? null,
      };
      (f.facturas_sii_vinculaciones || []).forEach((v) => {
        const key = refKeyDeVinculacion(v);
        if (!key) return;
        map._byRef[key] = {
          facturaId: f.id,
          folio: f.folio,
          fechaEmision: f.fecha_emision,
          montoNeto,
          montoAplicado: v.monto_aplicado ?? null, // F3: fuente única del importe por fila
          montoTotal: f.monto_total,
          tipoDte: f.tipo_dte,
          plazocobro: f.plazocobro ?? null,
          facturafechacobro: f.facturafechacobro ?? null,
          estadoFactoring: f.estado_factoring ?? null,
        };
      });
    });
    setSiiMap(map);
    // P2.100: `_displayFolio` sale del puente, así que se recalcula con el siiMap nuevo en cada fila (su
    // refKey sale de sus propios IDs, 10.7/10.234) — sin releer el dataset. Solo `_displayFolio`:
    // `_cobroReal`/`plazocobro`/`facturafechacobro` quedan como los dejó la carga (bloqueo Fase 3).
    setTodasOportunidades((prev) => {
      let cambio = false;
      const next = prev.map((op) => {
        const _displayFolio = derivarDisplayFolio(op, map);
        if (_displayFolio === op._displayFolio) return op;
        cambio = true;
        return { ...op, _displayFolio };
      });
      return cambio ? next : prev;
    });

    // Recargar también factoringMap (cuando se vincula/anula/liquida desde el modal DTE). Misma
    // fuente única que la carga inicial (10.1/10.27).
    setFactoringMap(await getFactoringInfoPorFactura(pais));
  };

  const isDataLoaded =
    todasOportunidades.length > 0 && intermediarios.length > 0 && clientes.length > 0 && usuarios.length > 0;

  return {
    todasOportunidades,
    setTodasOportunidades,
    intermediarios,
    clientes,
    usuarios,
    ejecutivosUnicos,
    siiMap,
    factoringMap,
    pctMap,
    recargarSiiMap,
    isDataLoaded,
  };
};
